module.exports = __webpack_public_path__ + "d1e41b59c942f200e2af5cd00a1c413c.woff";